const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const ssoHost = publicConfig.external_address;

exports.Listings = {
  read: function readListing (path, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/listings/${path}`,
      method: 'GET'
    };
    httpLib.request(requestParams, function request (response) {
      callback(response);
    });
  },

  update: function updateListing (query, token, payload, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/listings/${query}`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(requestParams, function listingUpdateCB (response) {
      callback(response);
    }, payload);
  },

  searchByIDs: function searchByIDs (listings, callback) {
    const listingsString = listings.join('&id=');
    const requestParams = {
      host: ssoHost,
      path: `/v1/search/listings?id=${listingsString}`,
      method: 'GET'
    };

    httpLib.request(requestParams, function request (response) {
      callback(response);
    }, null);
  },

  readBySpaceID: function readBySpaceID (parentSpaceID, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/listings?parent_space_id=${parentSpaceID}`,
      method: 'GET'
    };

    httpLib.request(requestParams, function request (response) {
      callback(response);
    }, null);
  },

  queryListings: function queryListings (query, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/listings/${query}`,
      method: 'GET'
    };
    httpLib.request(requestParams, function request (response) {
      callback(response);
    }, null);
  }
};
